export const error = (state) => state.error;
export const isLoading = (state) => state.isLoading;
export const items = (state) => state.items.results;
export const count = (state) => state.items.count;
